import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import {
  Container,
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
  Table,
  Button,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import useFetch from "../utils/UseFetch.jsx";
import { useNavigate, useLocation } from "react-router-dom";
import {
  token,
  bidheader,
  bidheaderNoCompany,
  submitBidLines,
  bidLinesWithCompany,
} from "../HelperFx/datalinks.js";
import { base64ToBlob, convertFileToBase64 } from "../HelperFx/common.js";
import BidLines from "./BidLines.jsx";
import Swal from "sweetalert2";
import { Row, Col } from "reactstrap";
// import CustomAppBar from "./appbar.jsx";

const eq = " eq ";

const REACT_APP_COMPANY = process.env.REACT_APP_COMPANY;
const REACT_APP_API_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_DATA_URL = REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = REACT_APP_COMPANY;

const Bid = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState([]);
  const [newSelectedFile, setNewSelectedFile] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const fileInputRef = useRef(null);
  const location = useLocation();
  const preqNo = location?.state?.bidNo || "";

  const {
    data: itemsLines,
    loading,
    error,
  } = useFetch(`${bidheader}&$filter=no${eq}'${preqNo}'`, token);

  const { data: bidLinesData } = useFetch(
    `${bidLinesWithCompany}&$filter=documentNo${eq}'${preqNo}'`,
    token,
  );

  const lvBidLinesData = bidLinesData?.value;

  const [formData, setFormData] = useState({
    systemId: "",
    no: "",
    rfpNo: "",
    postingDate: "",
    validToDate: "",
    description: "",
    status: "",
  });

  // Populate initial state from API
  useEffect(() => {
    if (itemsLines?.value?.length > 0) {
      setFormData(itemsLines.value[0]);
    }
  }, [itemsLines]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Update field on blur
  const handleBlur = async (e) => {
    const { name, value } = e.target;

    // Only update description
    if (name !== "description") return;

    try {
      await axios.patch(
        `${bidheaderNoCompany}(${formData.systemId})?${REACT_APP_COMPANY}`,
        { [name]: value },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${token}`,
            "If-Match": "*",
          },
        },
      );
      console.log(`Field "${name}" updated to "${value}"`);
    } catch (err) {
      console.error("Error updating field:", err);
    }
  };

  const makeAttachment = async (file, documentNo) => {
    // setIsModalLoading(true);
    if (!file) {
      Swal.fire("Error", "No file to Attach");
      // setIsModalLoading(false);
      return;
    }

    const fileContent = await convertFileToBase64(file);
    const fext = file.name;
    console.log("File extension:", fext); // Debug log

    const body = {
      FileName: file.name,
      fileType: fileContent.type,
      FileExtension: file.name.split(".").pop(),
      FileContentBase64: fileContent.split(",")[1],
      TableID: 50080,
      No: documentNo,
    };
    try {
      const response = await axios.post(
        `${REACT_DATA_URL}documentAttachments?${REACT_APP_COMPANY_URL}`,
        body,
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the file input
      }
      // setNewSelectedFile([]);
      setNewSelectedFile([]);
      await getDocumentAttachments(documentNo);
      console.log("Attachment response:", response.data); // Debug log
      Swal.fire("Success", "File attached successfully");
    } catch (error) {
      console.error("Error attaching file:", error);
      Swal.fire("Error", "Failed to attach file", "error");
    } finally {
      // setIsModalLoading(false);
    }
  };

  const getDocumentAttachments = async (documentNo) => {
    // setIsModalLoading(true);
    setNewSelectedFile((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(0);
      return updatedFiles;
    });

    try {
      const response = await axios.get(
        `${REACT_DATA_URL}documentAttachments?${REACT_APP_COMPANY_URL}&$filter=No eq '${documentNo}' and TableID eq 50080`,
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );
      console.log("Attachments:", response.data); // Debug log
      setSelectedFile(response.data.value);
      setNewSelectedFile([]);
    } catch (error) {
      console.error("Error fetching attachments:", error);
      Swal.fire("Error", "Failed to load attachments", "error");
    } finally {
      // setIsModalLoading(false);
    }
  };
  const downloadAttachment = async (systemId) => {
    // setIsModalLoading(true);
    try {
      const response = await axios.get(
        `${REACT_DATA_URL}documentAttachments(${systemId})?${REACT_APP_COMPANY_URL}`,
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );
      // console.log('Attachment response:', response.data.FileName); // Debug log
      const ext = response.data?.FileExtension;
      const blob = base64ToBlob(response.data?.FileContentBase64, ext);
      // console.log(blob);
      // console.log(ext);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${systemId}.${ext}`; // Set the desired file name
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading attachment:", error);
    } finally {
      // setIsModalLoading(false);
    }
  };

  // Submit Lines

  const submitBid = (bidNo) => {
    Swal.fire({
      title: `<span style="font-size:1.1rem">Do you want to Submit the bid for processing?</span>`,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const submitBidUrl = `${submitBidLines}`;
        const bidNo = location.state?.bidNo;
        //Console.log(draftNumber);
        try {
          const response = await fetch(submitBidUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${token}`,
            },
            body: JSON.stringify({ bidNo: bidNo }),
          });
          if (response.ok) {
            Swal.fire("Bid submitted successfuly!", "", "success").then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire("Error!", response.statusText, "error");
          }
        } catch (error) {
          console.error("Error Submiting bid:", error);
          Swal.fire("Error!", "Failed to submit Bid", "error");
        }
      } else if (result.isDismissed) {
        Swal.fire("Bid Submission cancelled", "", "info");
      }
    });
  };

  const exportBidLines = (rows) => {
    const exportData = rows.map((line) => ({
      systemSerialId: line.systemSerialId || line.systemId,
      lineno: line.lineNo,
      type: line.type,
      no: line.no,
      description: line.description,
      productLot: line.productLot,
      uom: line.uom,
      quantity: line.quantity,
      unitCost: line.unitCost,
      VatProdGr: line.VatProdGr,
      ndaRegistrationNo: line.ndaRegistrationNo,
      manufacturer: line.manufacturer,
      manufactureProductDescription: line.manufactureProductDescription,
      brandName: line.brandName,
      countryOfOrigin: line.countryOfOrigin,
      supplierCurrency: line.supplierCurrency,
      pmtTerms: line.pmtTerms,
      prepaymentPercentage: line.prepaymentPercentage,
      leadTimeXWorks: line.leadTimeXWorks,
      leadTimeFreshProdinDays: line.leadTimeFreshProdinDays,
      totalShelfLifeProd: line.totalShelfLifeProd,
      qtyperCarton: line.qtyperCarton,
      cartonDimension: line.cartonDimension,
      weightPerCarton: line.weightPerCarton,
      volPerCarton: line.volPerCarton,
      noOfPallets: line.noOfPallets,
      cartonsPerPallet: line.cartonsPerPallet,
      noOfContainers: line.noOfContainers,
      exUnitPrice: line.exUnitPrice,
      ddpJmsUnitPrice: line.ddpJmsUnitPrice,
      comentOrRemark: line.comentOrRemark,
      isBUBU: line.isBUBU,
      isCosignment: line.isCosignment,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Bid Lines");

    XLSX.writeFile(workbook, `BidLines.xlsx`);
  };

  const handleUploadExcel = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const filteredData = jsonData.filter((row) =>
          row.some((cell) => cell !== null && cell !== ""),
        );

        const newLines = filteredData.slice(1).map((row) => ({
          systemId: row[0] || "",
          lineNo: row[1],
          type: row[2] || "",
          no: row[3] || "",
          description: row[4] || "",
          productLot: row[5] || "",
          uom: row[6] || "",
          quantity: row[7] || 0,
          unitCost: parseFloat(row[8]?.toString().trim()) || 0,
          VatProdGr: row[9] || "",
          ndaRegistrationNo: String(row[10]) || "",
          manufacturer: row[11] || "",
          manufactureProductDescription: row[12] || "",
          brandName: row[13] || "",
          countryOfOrigin: row[14] || "",
          supplierCurrency: row[15] || "",
          paymentTerms: row[16] || "",
          prepaymentPercentage: parseFloat(row[17]?.toString().trim()) || 0,
          leadTimeForExWorksInDays: parseInt(row[18]?.toString().trim()) || 0,
          leadTimeForFreshProdInDays: parseInt(row[19]?.toString().trim()) || 0,
          totalShelfLifeOfProduct: row[20] || "",
          qtyPerCarton: row[21] || 0,
          cartonDimension: row[22] || "",
          weightPerCarton: row[23] || 0,
          volumePerCarton: row[24] || 0,
          noOfPallets: parseInt(row[25]?.toString().trim()) || 0,
          cartonsPerPallets: row[26] || 0,
          noOfContainers: parseInt(row[27]?.toString().trim()) || 0,
          exUnitPrice: parseFloat(row[28]?.toString().trim()) || 0,
          ddpJmsUnitPrice: parseFloat(row[29]?.toString().trim()) || 0,
          comentOrRemark: row[30] || "",
          isBUBU: row[31]?.toString().trim() || "",
          isCosignment: row[32]?.toString().trim() || "",
          lineAmount: parseFloat(row[6] || 0) * parseFloat(row[7] || 0) || 0,
        }));

        let successCount = 0;
        const errors = [];

        for (const line of newLines) {
          const requestBodyLine = {
            documentNo: location.state?.bidNo,
            rfpNo: location.state?.rfpNo,
            lineNo: parseInt(line.lineNo),
            type: line.type,
            no: line.no,
            description: line.description,
            productLot: line.productLot,
            uom: line.uom,
            quantity: parseFloat(line.quantity),
            unitCost: parseFloat(line.unitCost),
            VatProdGr: line.VatProdGr,
            ndaRegistrationNo: line.ndaRegistrationNo,
            manufacturer: line.manufacturer,
            manufactureProductDescription: line.manufactureProductDescription,
            brandName: line.brandName,
            countryOfOrigin: line.countryOfOrigin,
            supplierCurrency: line.supplierCurrency,
            pmtTerms: line.paymentTerms,
            prepaymentPercentage: parseFloat(line.prepaymentPercentage),
            leadTimeXWorks: parseInt(line.leadTimeForExWorksInDays),
            leadTimeFreshProdinDays: parseInt(line.leadTimeForFreshProdInDays),
            totalShelfLifeProd: line.totalShelfLifeOfProduct,
            qtyperCarton: parseInt(line.qtyPerCarton),
            cartonDimension: line.cartonDimension,
            noOfPallets: parseInt(line.noOfPallets),
            noOfContainers: parseInt(line.noOfContainers),
            weightPerCarton: parseFloat(line.weightPerCarton),
            volPerCarton: parseFloat(line.volumePerCarton),
            cartonsPerPallet: parseInt(line.cartonsPerPallets),
            exUnitPrice: parseFloat(line.exUnitPrice),
            ddpJmsUnitPrice: parseFloat(line.ddpJmsUnitPrice),
            comentOrRemark: line.comentOrRemark,
            isBUBU: line.isBUBU,
            isCosignment: line.isCosignment,
          };

          try {
            const lineResponse = await fetch(
              `${REACT_DATA_URL}bidlines?${REACT_APP_COMPANY_URL}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                  Authorization: `Basic ${token}`,
                  "If-Match": "*",
                },
                body: JSON.stringify(requestBodyLine),
              },
            );

            if (!lineResponse.ok) {
              let errorDetail = `HTTP ${lineResponse.status}`;

              try {
                const errorData = await lineResponse.json();
                console.error("Business Central Error Response:", errorData);

                if (errorData?.error) {
                  const err = errorData.error;
                  errorDetail = `${err.code || "Error"}: ${err.message || "Unknown error"}`;
                } else if (errorData?.message) {
                  errorDetail = errorData.message;
                }
              } catch (jsonErr) {
                errorDetail = await lineResponse.text();
              }

              errors.push({ itemNo: line.no || "N/A", error: errorDetail });
              console.error(`Failed to save ${line.no}:`, errorDetail);
              continue;
            }

            await lineResponse.json();
            successCount++;
          } catch (err) {
            errors.push({ itemNo: line.no || "N/A", error: err.message });
            console.error(err);
          }
        }

        // Final User Feedback
        if (errors.length === 0) {
          Swal.fire({
            title: "Success!",
            text: `All ${successCount} lines uploaded successfully.`,
            icon: "success",
          });
          window.location.reload();
          // setRefreshKey(1);
        } else {
          let errorMsg = `<strong>Uploaded ${successCount} lines successfully.</strong><br><br><strong>Errors:</strong><br>`;

          errors.forEach((err, i) => {
            errorMsg += `${i + 1}. <strong>Item ${err.itemNo}</strong>: ${err.error}<br>`;
          });

          Swal.fire({
            title: "Partial Success",
            html: errorMsg,
            icon: "warning",
            confirmButtonText: "OK",
          });
          // setRefreshKey(1);
        }

        // Refresh the lines (you may prefer to refetch instead)
        // setFormData((prev) =>
        //   prev.some((line) => Object.values(line).some((val) => val !== ""))
        //     ? [...prev, ...newLines]
        //     : newLines,
        // );
      } catch (error) {
        console.error("Excel processing error:", error);
        Swal.fire("Error", "Failed to process Excel file", "error");
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const removeAttachment = (systemId, documentNo) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // setIsModalLoading(true)
        axios
          .delete(
            `${REACT_DATA_URL}documentAttachments(${systemId})?${REACT_APP_COMPANY_URL}`,
            {
              headers: {
                Authorization: `Basic ${token}`,
              },
            },
          )
          .then((r) => {
            getDocumentAttachments(documentNo);
            // setIsModalLoading(false);
          })
          .catch((e) => {
            // setIsModalLoading(e)
          });
      }
    });
  };
  const handleSelectedFiles = (e) => {
    const files = e.target.files;
    setNewSelectedFile(Array.from(files));
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 2, ml: 0 }}>
      {/* <CustomAppBar active="bids" /> */}

      <Box sx={{ display: "flex", mb: 2 }}>
        <Button
          variant="contained"
          size="small"
          onClick={() => navigate(-1)}
          sx={{
            whiteSpace: "nowrap",
            backgroundColor: "#844646ff",
            px: 3,
            py: 1.5,
            mr: 2,
          }}
        >
          Back
        </Button>
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleUploadExcel}
          style={{ display: "none" }}
          id="upload-excel"
        />

        <Button
          variant="contained"
          size="small"
          // onClick={() => submitDocument(location.state?.PreqNo)}
          onClick={() => document.getElementById("upload-excel").click()}
          sx={{
            px: 3,
            py: 1.5,
            backgroundColor: "#844646ff",
            px: 3,
            py: 1.5,
            mr: 2,
          }}
        >
          Upload Data File
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => exportBidLines(lvBidLinesData)}
          sx={{
            px: 3,
            py: 1.5,
            backgroundColor: "#844646ff",
            px: 3,
            py: 1.5,
            mr: 2,
          }}
        >
          Export Lines
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => submitBid(preqNo)}
          sx={{
            px: 3,
            py: 1.5,
            backgroundColor: "#844646ff",
            px: 3,
            py: 1.5,
            mr: 2,
          }}
        >
          Submit
        </Button>
        <Button
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          size="small"
          variant="contained"
          sx={{
            whiteSpace: "nowrap",
            backgroundColor: "#844646ff",
            px: 3,
            py: 1.5,
          }}
          onClick={() => getDocumentAttachments(preqNo)}
        >
          Attach
        </Button>
      </Box>

      {/* {attShow && ( */}
      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Attachments
              </h5>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
            <div className="modal-body">
              <Row className="mb-2">
                <Col md={6} sm={12}>
                  <div className="mb-3">
                    <label htmlFor="floatingnameInput" className="mb-1">
                      Attach File
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => handleSelectedFiles(e)}
                      ref={fileInputRef}
                    />
                  </div>
                </Col>
                <Col md={4}></Col>
                <Col md={2} sm={12}>
                  <a
                    href="#15"
                    className="btn btn-sm border-black action-btn mt-4"
                    onClick={(e) => {
                      e.preventDefault();
                      makeAttachment(newSelectedFile[0], preqNo);
                    }}
                  >
                    Attach
                  </a>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={12}>
                  {selectedFile.length > 0 || newSelectedFile.length > 0 ? (
                    <div className="table-responsive">
                      <Table className="table table-striped table-sm mb-4">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>File</th>
                            <th>Remove</th>
                          </tr>
                        </thead>
                        <tbody>
                          {newSelectedFile.map((a, k) => (
                            <tr key={k}>
                              <td style={{ verticalAlign: "middle" }}>
                                {k + 1}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {a.name}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <div className="d-flex gap-3">
                                  {/* <Link
                                                        to="#"
                                                        className="text-danger"
                                                        // onClick={() => removeFile(k)}
                                                    >
                                                        Remove
                                                    </Link> */}
                                </div>
                              </td>
                            </tr>
                          ))}
                          {selectedFile.map((a, k) => (
                            <tr key={k} className="py-1">
                              <td style={{ verticalAlign: "middle" }}>
                                {k + 1}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    downloadAttachment(a.SystemId);
                                  }}
                                >
                                  {a.FileName}
                                </Link>
                              </td>
                              <td
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {" "}
                                <>
                                  <div className="d-flex gap-3">
                                    <Link
                                      to="#10"
                                      className="text-danger"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        removeAttachment(a.SystemId, a.no);
                                      }}
                                    >
                                      Remove
                                    </Link>
                                  </div>
                                </>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-file-question text-warning display-4" />
                      </div>
                      <h6>No file attached</h6>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>

      {loading && <Typography>Loading...</Typography>}
      {error && <Typography color="error">Error: {error.message}</Typography>}

      {!loading && (
        <Card sx={{ p: 1 }}>
          <CardContent>
            <Grid container spacing={1}>
              {Object.keys(formData)
                .filter(
                  (field) =>
                    field === "no" ||
                    field === "rfpNo" ||
                    field === "postingDate" ||
                    field === "validToDate" ||
                    field === "description" ||
                    field === "status",
                )
                .map((field) => (
                  <Grid item xs={12} sm={6} lg={4} key={field}>
                    <TextField
                      name={field}
                      label={field
                        .replace(/([A-Z])/g, " $1")
                        .replace(/^./, (str) => str.toUpperCase())}
                      value={formData[field] || ""}
                      size="small"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      margin="normal"
                      fullWidth
                      disabled={true}
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#000", // value color
                          color: "#000",
                        },
                        "& .MuiInputLabel-root.Mui-disabled": {
                          color: "#000", // label color
                        },
                      }}
                    />
                  </Grid>
                ))}
            </Grid>
          </CardContent>
        </Card>
      )}
      <BidLines
        docNo={preqNo}
        rfpNo={formData?.rfpNo}
        Status={formData?.status}
        // refreshKey={refreshKey}
      />
    </Container>
  );
};

export default Bid;
